export const ConsultingTree = {
    ExternConsulting: [
        {
            title: 'Finanzierung des Studiums',
            href: 'https://www.stw.berlin/finanzierung.html'
        },
        {
            title: 'Stipendien',
            href: 'https://www.stipendienlotse.de/datenbank.php?A%5B%5D=2&H=&B%5B%5D=4&F=57&S=&job=search'
        },
        {
            title: 'Finanzielle Hilfen ',
            href: 'https://www.stw.berlin/beratung/themen/finanzelle-hilfen.html'
        },
        {
            title: 'Wohnungssuche',
            href: 'https://www.stw.berlin/wohnen.html#jump_wohnraumb%C3%B6rsen'
        },
        {
            title: ' Studierenden-Jobs',
            href: 'https://www.stw.berlin/jobben.html#jump_jobs_&_trainings_f%C3%BCr_studierende'
        },
        {
            title: 'Hilfe bei Zweifel am Studium ',
            href: 'https://www.studienabbruch-und-dann.de/de/fragen-und-antworten-60.html'
        },
        {
            title: 'Hilfe bei Studienabbruch ',
            href: 'https://www.queraufstieg-berlin.de'
        },
    ],
    ConsultingCard: [
        {
            title: 'Referat für Studienangelegenheiten',
            paragraph: 'Hier erhalten Sie Informationen und Beratung zu allen allgemeinen und organisatorischen Fragen in puncto Studium.',
            tel: "+49 30 450 576 042 ",
            address: "Hannoversche Str. 19, 3.OG",
            talk: ["Mo-Fr 09:00-12:00, Mo-Do 13:00-16:00(Telefonisch)", "Di, Do, Fr: 9:30-12:30, Di 13:30-16:00(Sprechzeiten)"],
            href: 'https://www.charite.de/studium_lehre/struktur_einrichtungen/referat_fuer_studienangelegenheiten/'
        },
        {
            title: 'Fachschaft Initiative Medizin (FSI Medizin)',
            paragraph: 'Die Fachschaftsinitiative ist die Interessenvertretung der Medizinstudierenden an der Charité Universitätsmedizin Berlin. Unter dem Dach der FSI arbeiten zahlreiche Arbeitsgruppen. Darüber hinaus ist die FSI in nahezu allen Gremien an der Charité vertreten.',
            tel: "+49 30 450 576050",
            emails: ["sprecher@fsi-charite.de"],
            address: "Philippstraße 12, “Hexenhaus”, CCM",
            talk: ['Sprechzeiten nach Terminvereinbarung'],
            href: 'http://fsi-charite.de'
        },
        {
            title: 'MediCoach',
            paragraph: 'MediCoach bietet ein individuelles, kostenloses, lösungsorientiertes Coaching zur Unterstützung bei Stressbelastungen, die sich direkt aus dem Studium oder auch durch private Lebensumstände ergeben. MediCoach möchte dabei unterstützen, die Studienzeit gewinnbringend und bei guter Gesundheit nutzen zu können. Die Beratungen finden nach Bedarf in ein- oder mehrmaligen Einzelgesprächen oder Gruppensitzungen statt.',
            tel: " +49 30 450 529189",
            emails: ["medicoach@charite.de"],
            talk: ['Gespräch nach Terminvereinbarung'],
            href: 'https://medicoach.charite.de/fuer_studierende'
        },
        {
            title: "Peer Mentoring",
            paragraph: 'Das Peer-Mentoring-Programm richtet sich an Studienanfänger*innen im ersten und zweiten Semester und soll der Orientierung am Studienbeginn dienen. Dazu finden regelmäßige Treffen zwischen Mentor*in und Mentees statt.',
            emails: ["peer-mentoring@charite.de"],
            talk: ['Sprechzeiten nach Terminvereinbarung'],
            href: 'https://mentoring.charite.de/fuer_studienanfaenger/'
        },
        {
            title: 'Familienbüro',
            paragraph: 'Familienbüro:Sie studieren an der Charité und betreuen Kinder? Sie suchen einen Kitaplatz? Sie pflegen Angehörige? Sie haben Fragen und benötigen Informationen rund um das Thema Vereinbarkeit von Studium und Familie?',
            tel: "+49 030 450 577 257",
            emails: ["familienbuero@charite.de", "vaeterbeauftragte@charite.de"],
            address: "Westring 1, 1. Etage, R1.1011 CVK",
            talk: ["CVK: dienstags von 11:00 bis 13:00 Uhr, Gästehaus R.0.0120", "CCM: mittwochs von 11:00 bis 13:00 Uhr, Hufelandweg 2, EG, Raum 56|57"],
            href: 'https://familienbuero.charite.de/charite_mit_kind/studieren_mit_familie/kinderbetreuung'
        },
        {
            title: "Charité International Cooperations (ChiC)",
            paragraph: 'ChiC bietet Informationen und Unterstützung rund um die Themen Studieren im Ausland bzw. aus dem Ausland und Unterstützung von internationalen Studierenden in Berlin.',
            tel: "+49 30 450 576 088 ",
            emails: ["erasmixpaten@charite.de"],
            address: ["Reinhardtstr. 58, CCM"],
            talk: ['Sprechzeiten nach Terminvereinbarung'],
            href: 'https://www.charite.de/international/fuer_studierende/'
        },
        {
            title: 'Student Mentoring',
            paragraph: 'Das Team des Mentoringprogramms unterstützt Studierende, ihr Studium erfolgreich und zielstrebig zu absolvieren. Im Mentoringprogramm werden Studierenden engagierte Ärztinnen und Ärzte als Mentor*innen vermittelt.',
            tel: "+49 30 450 576 091",
            emails: ["studentmentoring@charite.de"],
            talk: ['Sprechzeiten nach Terminvereinbarung'],
            href: 'https://studentmentoring.charite.de'
        },
        {
            title: 'Frauen- und Gleichstellungsbeauftragte',
            paragraph: 'Hier finden Sie Informationen zu allen wichtigen Aktivitäten und Veranstaltungen,die für die Gleichstellung von Frauen und Männern an der Charité unternommen werden. Unsere Handlungsfelder umfassen Themen wie Karriereplanung, Diversity oder Vereinbarkeit von Familie und Beruf.',
            tel: "+49 30 450 577 252",
            address: "Westring 1, CVK",
            talk: ['Sprechzeiten nach Terminvereinbarung'],
            href: 'https://frauenbeauftragte.charite.de/'
        },
        {
            title: 'Schwerbehinderten Vertretung',
            paragraph: 'Die Gesamtschwerbehindertenvertretung (GSBV) der Charité – Universitätsmedizin Berlin vertritt die Interessen der schwerbehinderten oder gleichgestellten Kolleg*innen in der Charité.',
            tel: "+49 30 450 576 446",
            address: "Hindenburgdamm 30, 12203 Berlin, CBF , Geländeadresse: Haus II, 3. Obergeschoss, Raum 302",
            talk: ['Sprechzeiten nach Terminvereinbarung'],
            href: ' https://gsbv.charite.de'
        },
        {
            title: 'Geschäftsstelle für gute wissenschaftliche Praxis',
            paragraph: 'Die Geschäftsstelle Gute wissenschaftliche Praxis berät bei methodischen Fragen,bei Fragen der Datenerhebung, Bildbearbeitung und der statistischen Auswertung, oder vermittelt den Kontakt zu Expert*innen, die weiterhelfen.',
            tel: "+49 30 450 576 056",
            emails: ["gwp@charite.de",],
            talk: ['Sprechzeiten nach Terminvereinbarung'],
            href: 'https://promotion.charite.de/fuer_promovierende/#c30201158'
        }
    ]
}
